(function () {
    if (window.__curaproxMegaAccordion) return;
    window.__curaproxMegaAccordion = true;

    var COL = '.mega-menu__column';
    // Curaprox (client feedback 2026-07-21 — Jan Krammer): touch tablets (>=750px) are served
    // the DESKTOP mega-menu (see [[tablet-nav-tap-to-open]]); the top-level panel now taps open,
    // but the sub-sections here open ONLY on hover-intent (the 500ms `:hover` re-check below,
    // which a tap never satisfies) so tapping a category like "Toothbrushes" did nothing. On a
    // no-hover pointer, drive the sections by an explicit tap-to-toggle instead (see the click
    // handler below), and disable the hover path so exactly ONE opener is live per pointer type.
    var COARSE_POINTER = matchMedia('(hover: none), (pointer: coarse)');
    // Hover-INTENT (client feedback 2026-07): switching to ANY other sub-section requires
    // the cursor to rest on it for a brief moment before it opens — in BOTH directions, not
    // just downward. This stops the sub-nav from nervously flipping panels while the cursor
    // sweeps across sections and reduces accidental panel changes. The panel now opens with
    // no section expanded (client feedback 2026-07 — Jan Krammer); a section opens only on a
    // deliberate hover, so the first row is no longer pre-opened.
    // Client feedback: 200ms (matching the main links) still let sub-sections open by ACCIDENT
    // when the cursor sweeps across the column list. This is a dedicated, longer HOVER-INTENT
    // delay: only a deliberate pause on one of the 4 category rows opens it. Set to 500ms
    // (client feedback 2026-07) so quick cursor sweeps across the column no longer flip panels;
    // still responsive to an intentional hover. This ONLY has a visible effect because the
    // expand CSS is now gated on `.is-open` (set here after the delay), not on bare `:hover`
    // (see the stylesheet note above). Decoupled from the main-link `--nav-underline-speed`
    // on purpose; tune here if needed.
    var SECTION_HOVER_DELAY_MS = 500;

    var pendingTimer = null;
    var pendingCol = null;

    var hasSublist = function (col) {
      return !!col.querySelector(':scope > div > ul');
    };

    function cancelPending() {
      if (pendingTimer) {
        clearTimeout(pendingTimer);
        pendingTimer = null;
      }
      pendingCol = null;
    }

    function activate(col) {
      var card = col.closest('.menu-list__submenu');
      if (!card) return;
      card.querySelectorAll(COL + '.is-open').forEach(function (c) {
        if (c !== col) c.classList.remove('is-open');
      });
      col.classList.add('is-open');
    }

    function clearCard(card) {
      cancelPending();
      card.querySelectorAll(COL + '.is-open').forEach(function (c) {
        c.classList.remove('is-open');
      });
    }

    function onEnterSection(col) {
      var card = col.closest('.menu-list__submenu');
      if (!card) return;
      if (col.classList.contains('is-open')) {
        cancelPending();
        return;
      } // already open
      // Require a brief, intentional hover before switching to ANY other section
      // (regardless of whether it's above or below the currently-open one).
      if (pendingCol === col) return; // already counting down for this section
      cancelPending();
      pendingCol = col;
      pendingTimer = setTimeout(function () {
        pendingTimer = null;
        var c = pendingCol;
        pendingCol = null;
        if (c && c.matches(':hover')) activate(c); // only if still hovered after the delay
      }, SECTION_HOVER_DELAY_MS);
    }

    // Persist the last-hovered section (mouseenter doesn't bubble, so delegate mouseover).
    // Gated to fine pointers: on touch, `mouseover` fires on a tap and Chrome applies a sticky
    // `:hover` that could satisfy the delayed re-check, racing the tap-toggle below. The tap
    // handler is the sole opener on coarse pointers.
    document.addEventListener('mouseover', function (e) {
      if (COARSE_POINTER.matches) return;
      var t = e.target;
      if (!t || !t.closest) return;
      var col = t.closest(COL);
      if (!col || !hasSublist(col)) return;
      onEnterSection(col);
    });

    // Curaprox category parent = expand-only, never a destination (client feedback 2026-08 —
    // Jan Krammer): clicking a top-category row (Toothbrush, Toothpaste & Mouthwash, …) must
    // NOT open its collection page — it only reveals the sub-categories; the "View all" child
    // link is the way to the category page. This is intercepted on EVERY pointer type (was
    // touch-only 2026-07-21): on desktop the section already opens on hover-intent, so a click
    // just opens it (never collapse-on-click, so it doesn't fight the hover accordion); on a
    // no-hover pointer the click toggles (re-tap collapses; tapping another section switches).
    // Only the parent (`.mega-menu__link--parent`, present only when the section HAS children)
    // is intercepted — childless categories stay real navigating <a>s, and child links (incl.
    // "View all") navigate normally. The parent is now rendered as a <button> in
    // snippets/mega-menu-list.liquid (so it can NEVER navigate even if this script is blocked —
    // e.g. by Cookiebot pre-consent); this handler just drives the expand. The preventDefault
    // below is a harmless belt-and-suspenders (a <button type="button"> submits/navigates
    // nothing anyway).
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var parentLink = t.closest('.mega-menu__link--parent');
      if (!parentLink) return;
      var col = parentLink.closest(COL);
      if (!col || !hasSublist(col)) return;
      e.preventDefault();
      cancelPending();
      if (COARSE_POINTER.matches) {
        // touch: tap toggles the section open/closed
        if (col.classList.contains('is-open')) {
          col.classList.remove('is-open');
        } else {
          activate(col);
        }
      } else {
        // desktop/fine pointer: a click just opens the section (hover-intent governs the
        // rest); don't collapse on click so it never fights the hover accordion.
        activate(col);
      }
    });

    // header-menu.js toggles `data-active` on the submenu as the panel opens/closes.
    // The panel now opens with NO section expanded (client feedback 2026-07 — Jan
    // Krammer): a section only opens once the user deliberately hovers it. On close →
    // reset any open/pending section so the next open again starts fully collapsed.
    var observer = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        var el = m.target;
        if (!el || el.nodeType !== 1 || !el.matches('.menu-list__submenu')) return;
        if (!el.hasAttribute('data-active')) {
          clearCard(el);
        }
      });
    });
    function start() {
      observer.observe(document.body, {
        attributes: true,
        subtree: true,
        attributeFilter: ['data-active'],
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
